// import { Honeybadger, HoneybadgerErrorBoundary } from "@honeybadger-io/react";

import React from "react";

// const reportData = process.env.HONEYBADGER_REPORTDATA === "true";
// const config = {
//   apiKey: process.env.HONEYBADGER_API_KEY,
//   environment: process.env.NODE_ENV,
//   developmentEnvironments: ["development"],
//   reportData: reportData,
// };

var isProd = process.env.NODE_ENV !== "development";
// const enabledHoneyBager = isProd ? Honeybadger.configure(config) : null;

var ErrorNotifierProvider = function ErrorNotifierProvider(_ref) {
  var _ref$ErrorComponent = _ref.ErrorComponent,
    ErrorComponent = _ref$ErrorComponent === void 0 ? null : _ref$ErrorComponent,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  // isProd && return (
  //   <>
  //        <HoneybadgerErrorBoundary
  //           honeybadger={enabledHoneyBager}
  //           ErrorComponent={ErrorComponent}
  //         >
  //         {children }
  //        </HoneybadgerErrorBoundary>

  //   </>
  // );
};
export default ErrorNotifierProvider;